import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { push } from 'react-router-redux';
import { Link } from 'react-router';

import { deleteCustomer2, customerDeleted } from '../../actions/company';
import NavBarConfig from '../../components/NavBarConfig';
import CustomerDelete from './components/CustomerDelete';
import { FORM_ERROR } from 'final-form';

const messages = defineMessages({
  BACK: {
    id: 'CustomerDeletePage.BACK',
    defaultMessage: 'Zurück',
  },
  DELETE_CUSTOMER: {
    id: 'CustomerDeletePage.DELETE_CUSTOMER',
    defaultMessage: 'Kunde löschen',
  },
  QUESTION_DELETE_USER: {
    id: 'CustomerDeletePage.QUESTION_DELETE_USER',
    defaultMessage: 'Sind sie sich sicher, dass sie diese Kunde wirklich löschen wollen?',
  },
  ACTION_CAN_NOT_REVOKED: {
    id: 'CustomerDeletePage.ACTION_CAN_NOT_REVOKED',
    defaultMessage: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
});

function CustomerDeletePage({ company, customer, onSubmit, routes, location, intl: { formatMessage } }) {
  if (!customer) { return null; }
  const fromList = location && location.query && location.query.from === 'list';
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig deletePage currentRouteName={routes[routes.length - 1].name} />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={fromList ? `/company/${company.id}/customer/` : `/company/${company.id}/customer/${customer.id}/update/`} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.DELETE_CUSTOMER)}
            </h2>
          </div>

          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <div style={{ padding: '16px', backgroundColor: 'rgba(239, 68, 68, 0.1)', borderLeft: '4px solid #ef4444', borderRadius: '8px', marginBottom: '24px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <i className="fa fa-exclamation-triangle" style={{ color: '#ef4444', fontSize: '20px', marginTop: '2px' }} />
              <div>
                <p style={{ margin: 0, color: 'var(--text-color)', fontSize: '14px', fontWeight: '500' }}>
                  {formatMessage(messages.QUESTION_DELETE_USER)}
                  <br />
                  {formatMessage(messages.ACTION_CAN_NOT_REVOKED)}
                </p>
              </div>
            </div>
            
            <CustomerDelete
              style={{ marginTop: '15px' }}
              onSubmit={onSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null,
  (dispatch, { params: { companyId, customerId } }) => ({
    onSubmit: async () => {
      const data = await deleteCustomer2(companyId, customerId);
      if (data.response === null || (data.response && data.response.error === null)) {
        dispatch(customerDeleted({ companyId, customerId }));
        dispatch(push(`/company/${companyId}/customer/`));
        /* global window */
        window.location.reload();
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    }
  })
)(injectIntl(CustomerDeletePage));
